import easydropdown from "easydropdown-a11y";
import "@styles/components/dropdown.css";
import { on } from "delegated-events";
import ajax from "@common/ajax";
import scrollTo from "@common/scroll-to";
import { slideUp, slideDown } from "@common/slide";
import { generateQueryString } from "@common/util";

const form = document.querySelector(".filter-form");

const setupDropdown = (el) => {
  if (el.tagName !== "SELECT") {
    return;
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
  };

  easydropdown(el, opts);
};

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = () => {
  form.reset();
  form.querySelectorAll("select").forEach((x) => (x.value = ""));
  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));

  window.history.replaceState({}, "", form.action);

  updateResults();
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    form.classList.add("is-filtered");
    scrollTo(pageContent);
  } else {
    form.classList.remove("is-filtered");
  }
};

const init = () => {
  form.querySelectorAll("select:not([multiple])").forEach((el) => setupDropdown(el));

  on("change", ".filter-form select", handleFilterChange);
  on("submit", ".filter-form", handleFilterChange);
  on("click", ".filter-form-clear", handleFilterClear);

  on("click", ".faq-toggle-all", (e) => {
    const holder = e.target.closest(".faq-group");
    const items = holder.querySelectorAll(".faq-item");
    const type = e.target.dataset.type;

    if (type === "open") {
      items.forEach(async (item) => {
        const target = document.getElementById(item.getAttribute("aria-controls"));
        item.setAttribute("aria-expanded", "true");
        item.parentNode.classList.add("is-active");

        await slideDown(target);
      });
    }

    if (type === "close") {
      items.forEach(async (item) => {
        const target = document.getElementById(item.getAttribute("aria-controls"));
        item.setAttribute("aria-expanded", "false");
        item.parentNode.classList.remove("is-active");

        await slideUp(target);
      });
    }
  });

  const faqGroups = document.querySelectorAll(".faq-group");

  const observer = new MutationObserver((mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes" && mutation.attributeName === "aria-expanded") {
        faqGroups.forEach((el) => {
          const opened = el.querySelectorAll('.faq-item[aria-expanded="true"]').length;
          const toggle = el.querySelector(".faq-toggle-all");

          if (opened > 0) {
            toggle.textContent = "Close All";
            toggle.setAttribute("data-type", "close");
          }

          if (opened === 0) {
            toggle.textContent = "Open All";
            toggle.setAttribute("data-type", "open");
          }
        });
      }
    }
  });

  faqGroups.forEach((el) => {
    el.querySelectorAll(".faq-item").forEach((item) => {
      observer.observe(item, { attributes: true });
    });
  });
};

init();
